// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 50px;
  max-width: 100vw;
  margin-top: 40px;
}

.game-board {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.sortable-item.active {
  z-index: 999;
}

.guess-details {
  margin-top: 70px;
  color: var(--secondary-text);
}

.attempts-info {
  font-size: 1.3rem;
  font-weight: var(--nunito-medium);
}

.attempts-info span {
  font-size: 1.8rem;
  font-weight: var(--nunito-black);
  margin-left: 10px;
}

.guess-feedback {
  font-size: 1.8rem;
  font-weight: var(--nunito-black);
  margin-top: 5px;
}

.game-won {
  font-size: 1.8rem;
  font-weight: var(--nunito-black);
  margin-top: 5px;
  padding: 20px;
}

.game-lost {
  font-size: 1.8rem;
  font-weight: var(--nunito-black);
  margin-top: 5px;
  padding: 20px;
}

.solution-sequence {
  margin-top: 20px;
}

.match-button {
  background-color: var(--primary-text);
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-weight: var(--nunito-bold);
  color: var(--bg-color);
  font-size: 20px;
  width: 300px;
  height: 45px;
  margin-top: 40px;
}

.match-button:disabled,
.match-button[disabled] {
  background-color: lightgray;
  color: gray;
  cursor: not-allowed;
}

.attempts-history-container {
  text-align: center;
  margin: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.attempts-history-container ul {
  padding: 0;
  list-style-type: none;
}

.attempts-history-container li {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  border-bottom: 2px solid var(--secondary-text);
}

.attempts-history-container li:last-child {
  border-bottom: none;
}

.attempt-content {
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.attempt-number-wrapper,
.attempt-result-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px 10px;
  width: 64px;
  height: 64px;
}

.attempt-number,
.attempt-text,
.attempt-result-number,
.attempt-result-text {
  width: auto;
  text-align: center;
}

.attempt-number,
.attempt-result-number {
  font-size: 2rem !important;
  font-weight: var(--nunito-black) !important;
  margin: 0px !important;
}

.attempt-result-number {
  color: var(--secondary-text) !important;
}

.animate {
  animation: bounceScale 1s ease-in-out;
}

.latest-attempt .attempt-result-number {
  animation: bounceScale 1s ease-in-out;
}

.attempt-text,
.attempt-result-text {
  font-size: 0.9rem !important;
  margin: 0px !important;
}

.attempt-result-text {
  color: var(--secondary-text) !important;
}

.attempt-items {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 2 1;
}

.attempts-history-container p {
  color: var(--primary-text);
  font-weight: var(--nunito-medium);
  font-size: 1.2rem;
  margin: 8px 0;
}

.attempt-result-wrapper {
  text-align: right;
}

.attempt-image {
  width: 50px;
  height: 50px;
  margin: 0 5px;
}

.disabled {
  cursor: default;
}

@keyframes bounceScale {
  0%,
  100% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.6);
  }
  50% {
    transform: scale(1.1);
  }
  70% {
    transform: scale(1.6);
  }
}

@media screen and (max-width: 1100px) {
  .sortable-container {
    gap: 20px;
  }

  .guess-details {
    margin-top: 50px;
  }

  .match-button {
    margin-top: 20px;
  }
}

@media screen and (max-width: 650px) {
  .sortable-container {
    gap: 5px;
  }

  .attempts-history-container li {
    flex-direction: column;
  }

  .attempt-stats {
    margin-bottom: 20px;
  }

  .attempt-content {
    gap: 35px;
  }
}

@media (hover: hover) {
  .match-button:hover {
    background-color: var(--secondary-text);
  }

  .light-theme .match-button:hover {
    background-color: var(--alt-color);
    color: var(--primary-text);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/gameBoard/GameBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;AACF","sourcesContent":[".sortable-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 50px;\r\n  max-width: 100vw;\r\n  margin-top: 40px;\r\n}\r\n\r\n.game-board {\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.sortable-item.active {\r\n  z-index: 999;\r\n}\r\n\r\n.guess-details {\r\n  margin-top: 70px;\r\n  color: var(--secondary-text);\r\n}\r\n\r\n.attempts-info {\r\n  font-size: 1.3rem;\r\n  font-weight: var(--nunito-medium);\r\n}\r\n\r\n.attempts-info span {\r\n  font-size: 1.8rem;\r\n  font-weight: var(--nunito-black);\r\n  margin-left: 10px;\r\n}\r\n\r\n.guess-feedback {\r\n  font-size: 1.8rem;\r\n  font-weight: var(--nunito-black);\r\n  margin-top: 5px;\r\n}\r\n\r\n.game-won {\r\n  font-size: 1.8rem;\r\n  font-weight: var(--nunito-black);\r\n  margin-top: 5px;\r\n  padding: 20px;\r\n}\r\n\r\n.game-lost {\r\n  font-size: 1.8rem;\r\n  font-weight: var(--nunito-black);\r\n  margin-top: 5px;\r\n  padding: 20px;\r\n}\r\n\r\n.solution-sequence {\r\n  margin-top: 20px;\r\n}\r\n\r\n.match-button {\r\n  background-color: var(--primary-text);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-weight: var(--nunito-bold);\r\n  color: var(--bg-color);\r\n  font-size: 20px;\r\n  width: 300px;\r\n  height: 45px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.match-button:disabled,\r\n.match-button[disabled] {\r\n  background-color: lightgray;\r\n  color: gray;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.attempts-history-container {\r\n  text-align: center;\r\n  margin: 30px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.attempts-history-container ul {\r\n  padding: 0;\r\n  list-style-type: none;\r\n}\r\n\r\n.attempts-history-container li {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 2px solid var(--secondary-text);\r\n}\r\n\r\n.attempts-history-container li:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.attempt-content {\r\n  width: 100%;\r\n  max-width: 800px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n.attempt-number-wrapper,\r\n.attempt-result-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin: 0px 10px;\r\n  width: 64px;\r\n  height: 64px;\r\n}\r\n\r\n.attempt-number,\r\n.attempt-text,\r\n.attempt-result-number,\r\n.attempt-result-text {\r\n  width: auto;\r\n  text-align: center;\r\n}\r\n\r\n.attempt-number,\r\n.attempt-result-number {\r\n  font-size: 2rem !important;\r\n  font-weight: var(--nunito-black) !important;\r\n  margin: 0px !important;\r\n}\r\n\r\n.attempt-result-number {\r\n  color: var(--secondary-text) !important;\r\n}\r\n\r\n.animate {\r\n  animation: bounceScale 1s ease-in-out;\r\n}\r\n\r\n.latest-attempt .attempt-result-number {\r\n  animation: bounceScale 1s ease-in-out;\r\n}\r\n\r\n.attempt-text,\r\n.attempt-result-text {\r\n  font-size: 0.9rem !important;\r\n  margin: 0px !important;\r\n}\r\n\r\n.attempt-result-text {\r\n  color: var(--secondary-text) !important;\r\n}\r\n\r\n.attempt-items {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex: 2;\r\n}\r\n\r\n.attempts-history-container p {\r\n  color: var(--primary-text);\r\n  font-weight: var(--nunito-medium);\r\n  font-size: 1.2rem;\r\n  margin: 8px 0;\r\n}\r\n\r\n.attempt-result-wrapper {\r\n  text-align: right;\r\n}\r\n\r\n.attempt-image {\r\n  width: 50px;\r\n  height: 50px;\r\n  margin: 0 5px;\r\n}\r\n\r\n.disabled {\r\n  cursor: default;\r\n}\r\n\r\n@keyframes bounceScale {\r\n  0%,\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n  30% {\r\n    transform: scale(1.6);\r\n  }\r\n  50% {\r\n    transform: scale(1.1);\r\n  }\r\n  70% {\r\n    transform: scale(1.6);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .sortable-container {\r\n    gap: 20px;\r\n  }\r\n\r\n  .guess-details {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .match-button {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 650px) {\r\n  .sortable-container {\r\n    gap: 5px;\r\n  }\r\n\r\n  .attempts-history-container li {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .attempt-stats {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .attempt-content {\r\n    gap: 35px;\r\n  }\r\n}\r\n\r\n@media (hover: hover) {\r\n  .match-button:hover {\r\n    background-color: var(--secondary-text);\r\n  }\r\n\r\n  .light-theme .match-button:hover {\r\n    background-color: var(--alt-color);\r\n    color: var(--primary-text);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
